import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/Purple/Tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c4b165d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pick-value-content" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = {
  key: 0,
  class: "values"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tick" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "tick"
  })
], -1))
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "pick-notification-value-container",
    "no-pad": "",
    title: _ctx.title
  }, {
    "left-button": _withCtx(() => [
      _createVNode(_component_BackButton)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            type: "text",
            placeholder: "search"
          }, null, 512), [
            [_vModelText, _ctx.searchText]
          ])
        ]),
        (_ctx.currentFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allOptions, (value, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass([
                        'value',
                        { active: _ctx.selectedValue === value[_ctx.name] },
                    ]),
                  onClick: ($event: any) => (_ctx.onSelectOption(value[_ctx.name]))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getFormattedText(
                                value[_ctx.name] === undefined ? 'All' : value[_ctx.name]
                            )), 1)
                ], 10, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Loading, { loading: _ctx.loading }, null, 8, ["loading"])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["title"]))
}